import React from "react";
import GetKibanaDashboard from "../../components/Common/HelperComponents/KibanaDashboardComponents/GetKibanaDashboard";
import InaccessibleResources from "../../helpers/InaccessibleResources";

const freeLicenseName = process.env.REACT_APP_FREE_ORGANIZATION_LICENSE;
const freeLicenses = [freeLicenseName];

/** FinOps → AWS Marketplace Insights (moved out of Cloud Spend tabs). */
const MarketplaceInsights = ({ licenseName, message }) => {
  if (freeLicenses.includes(licenseName)) {
    return <InaccessibleResources message={message} />;
  }
  return <GetKibanaDashboard dashboardKey={"marketplace_dashboard"} />;
};

export default MarketplaceInsights;
